'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productFiltersComponent = exports.productFiltersComponent = {
    template: require('./product-filters.html'),
    bindings: {
        filter: '<',
        paging: '=',
        changeFilters: '&',
        filternavFolder: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.changeFilterCategoryLimit = changeFilterCategoryLimit;
        vm.onChangeFilters = onChangeFilters;
        vm.expandFilters = expandFilters;
        vm.getFilterCategories = getFilterCategories;

        function getFilterCategories() {
            vm.expandFilters();
            return vm.filter.filterCategories;
        }

        function changeFilterCategoryLimit(category, limit) {
            category.limit = limit;
        }

        function onChangeFilters($event) {
            vm.changeFilters({ 'filter': $event.filter, 'category': $event.category });
        }
        function expandFilters() {
            var _this = this;

            if (!vm.filter.isAutoExpanded) {
                vm.filter.isAutoExpanded = true;
                vm.filter.filterCategories.forEach(function (category) {
                    for (var i = category.items.length - 1; i >= 0; i--) {
                        if (category.items[i].isSelected && i + 1 > category.limit) {
                            _this.changeFilterCategoryLimit(category, 9999);
                            break;
                        }
                    }
                });
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-filters.js
// module id = 971
// module chunks = 0